<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_lines' | translate }}"
    no_asset_text="{{ 'no_eligible_lines' | translate }}"
    [asset_fields]="['plan', 'contract_end_date', 'add_on_features']"
    [existing_asset]="existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>

<ng-template #confirmChangeCarrierModal>
  <ts-confirm-line-termination
    modal_header="{{ 'change_carrier' | translate }}"
    [asset]="asset.line"
    (confirmChangeCarrier)="changeCarrierContinue($event)"
  />
</ng-template>

<ng-template #multiSimConfirmation let-modal>
  <div class="modal-header">
    @if (asset.multi_sim_type === multi_sim_types[0] && !open_1LMD_modal) {
      <h4 class="modal-title">
        {{ 'multisim_device' | translate }}
      </h4>
    }
    @if (
      [multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type) || open_1LMD_modal
    ) {
      <h4 class="modal-title">
        {{ 'multisim_line' | translate }}
      </h4>
    }
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  @if (asset.multi_sim_type === multi_sim_types[0] && !open_1LMD_modal) {
    <div class="modal-body pt-0" name="1DML-modal-body">
      <div class="row mb-3">
        <div class="col">
          <span class="fw-light" [innerHTML]="multisimModalBody(asset)"></span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          @if (asset.multi_sim_type === multi_sim_types[0] && !open_1LMD_modal) {
            <span class="fw-light" [innerHTML]="multisimModalPrompt(asset)"> </span>
          }
        </div>
      </div>
      <ul class="list-group multisim-lines-modal-list">
        @if (asset?.device && asset?.line?.status === 'Active') {
          <li
            class="d-flex list-group-item list-group-item-action cursor-pointer"
            [ngClass]="{ active: lineInCart(asset.line) }"
            (click)="selectAsset(asset, true)"
          >
            {{ asset.line.international_number }} ({{ asset.line.carrier_name }})
            <span
              class="d-inline-block material-icons fs-inherit ms-1"
              [ngClass]="!lineInCart(asset.line) ? 'text-info' : ''"
            >
              verified
            </span>
          </li>
        }
        @for (additional_line of calculateModalAdditionalLines(); track additional_line) {
          <li
            class="list-group-item list-group-item-action cursor-pointer"
            [ngClass]="{ active: lineInCart(additional_line) }"
            (click)="selectAsset(additional_line, true, true)"
          >
            {{ additional_line.international_number }} ({{ additional_line.carrier_name }})
          </li>
        }
      </ul>
    </div>
  }

  @if ([multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type) || open_1LMD_modal) {
    <div class="modal-body pt-0" name="1LMD-modal-body">
      <div class="row mb-3">
        <div class="col">
          <span class="fw-light" [innerHTML]="multisimModalBody(asset)"> </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button type="button" class="btn btn-outline-secondary me-2" (click)="modal.dismiss()">
            {{ 'close' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</ng-template>
